import { InjectionToken } from '@angular/core';
import {
  OhayoDateRangePickerConfig,
  OhayoErrorCollectConfig,
  OhayoImageConfig,
  OhayoLoadingConfig,
  OhayoLodopConfig,
  OhayoMediaConfig,
  OhayoPageHeaderConfig,
  OhayoQRConfig,
  OhayoSEConfig,
  OhayoSGConfig,
  OhayoSTConfig,
  OhayoSVConfig,
  OhayoXlsxConfig,
  OhayoZipConfig,
} from './components/index';
import { OhayoACLConfig } from './acl/acl.type';
import { OhayoAuthConfig } from './auth/auth.type';
import { OhayoCacheConfig } from './cache/cache.type';
import { OhayoChartConfig } from './chart/chart.type';
import { OhayoMockConfig } from './mock/mock.type';
import { OhayoSFConfig } from './sf/sf.type';
import { OhayoThemeHttpClientConfig, OhayoThemeResponsiveConfig } from './theme/index';
import { OhayoUtilArrayConfig } from './util/array.type';

export interface OhayoConfig {
  dataRange?: OhayoDateRangePickerConfig;
  errorCollect?: OhayoErrorCollectConfig;
  image?: OhayoImageConfig;
  loading?: OhayoLoadingConfig;
  lodop?: OhayoLodopConfig;
  pageHeader?: OhayoPageHeaderConfig;
  qr?: OhayoQRConfig;
  se?: OhayoSEConfig;
  sg?: OhayoSGConfig;
  sv?: OhayoSVConfig;
  st?: OhayoSTConfig;
  sf?: OhayoSFConfig;
  xlsx?: OhayoXlsxConfig;
  zip?: OhayoZipConfig;
  media?: OhayoMediaConfig;
  acl?: OhayoACLConfig;
  auth?: OhayoAuthConfig;
  cache?: OhayoCacheConfig;
  chart?: OhayoChartConfig;
  mock?: OhayoMockConfig;
  utilArray?: OhayoUtilArrayConfig;
  themeHttp?: OhayoThemeHttpClientConfig;
  themeResponsive?: OhayoThemeResponsiveConfig;
}

export type OhayoConfigKey = keyof OhayoConfig;

export const OHAYO_CONFIG = new InjectionToken<OhayoConfig>('ohayo-config', {
  providedIn: 'root',
  factory: OHAYO_CONFIG_FACTORY,
});

export function OHAYO_CONFIG_FACTORY(): OhayoConfig {
  return {};
}
